const cards = [
  {
    title: '暗网三层结构详解',
    desc: '表层网、深网与暗网的区别和联系，了解互联网的隐藏层次与数据分布。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20layers%20visualization%20showing%20three%20tiers%20of%20internet%20structure%2C%20dark%20background%20with%20warm%20amber%20and%20copper%20highlights%2C%20conceptual%20data%20architecture%20art%2C%20minimalist%20composition%20with%20geometric%20depth%20layers%2C%20cybersecurity%20theme%20with%20subtle%20network%20patterns%2C%20no%20text%2C%20clean%20atmospheric%20aesthetic&width=800&height=500&seq=card-dark-web-layer&orientation=landscape',
    tag: '入门基础',
  },
  {
    title: 'Tor洋葱路由原理',
    desc: '详解Tor浏览器的洋葱路由加密机制，理解多层代理如何保护你的匿名性。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20onion%20routing%20concept%20visualization%20with%20concentric%20circular%20layers%20and%20encrypted%20data%20flows%2C%20dark%20background%20with%20warm%20amber%20glowing%20nodes%2C%20network%20security%20aesthetic%2C%20minimalist%20geometric%20composition%2C%20multi-layer%20protection%20visual%20metaphor%2C%20no%20text%2C%20atmospheric%20dark%20tech%20style&width=800&height=500&seq=card-tor-onion&orientation=landscape',
    tag: '技术解析',
  },
  {
    title: '暗网安全防护手册',
    desc: '从VPN选择到系统加固，完整暗网安全访问防护方案，避免信息泄露与追踪。',
    img: 'https://readdy.ai/api/search-image?query=Cybersecurity%20shield%20concept%20with%20digital%20protection%20layers%20and%20lock%20patterns%2C%20dark%20charcoal%20background%20with%20warm%20amber%20accents%2C%20abstract%20data%20protection%20visualization%2C%20minimalist%20security%20aesthetic%2C%20subtle%20circuit%20board%20patterns%2C%20clean%20atmospheric%20composition%20with%20depth%2C%20no%20text&width=800&height=500&seq=card-security-manual&orientation=landscape',
    tag: '安全指南',
  },
  {
    title: '暗网市场与交易警示',
    desc: '暗网常见市场类型介绍与交易风险警示，帮助你识别骗局与规避法律风险。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20marketplace%20concept%20with%20warning%20symbols%20and%20digital%20scales%2C%20dark%20background%20with%20crimson%20and%20amber%20accents%2C%20risk%20awareness%20visual%20metaphor%2C%20minimalist%20composition%20with%20geometric%20shapes%2C%20online%20transaction%20security%20theme%2C%2050:50%20ratio%2C%20no%20text%2C%20atmospheric%20tone&width=800&height=500&seq=card-market-warning&orientation=landscape',
    tag: '风险提示',
  },
  {
    title: '深度网搜索引擎指南',
    desc: '暗网专用搜索引擎大盘点，Torch、Ahmia、DuckDuckGo.onion等工具使用教程。',
    img: 'https://readdy.ai/api/search-image?query=Search%20engine%20concept%20with%20magnifying%20glass%20and%20deep%20web%20data%20streams%2C%20dark%20background%20with%20warm%20copper%20glow%20effects%2C%20abstract%20information%20retrieval%20visualization%2C%20minimalist%20digital%20exploration%20theme%2C%20interconnected%20search%20nodes%2C%20clean%20atmospheric%20composition%2C%20no%20text&width=800&height=500&seq=card-search-engine&orientation=landscape',
    tag: '工具推荐',
  },
  {
    title: '吃瓜爆料投稿须知',
    desc: '了解匿名投稿规范与内容审核标准，安全高效地分享你的暗网见闻与独家爆料。',
    img: 'https://readdy.ai/api/search-image?query=Anonymous%20tip%20submission%20concept%20with%20envelope%20and%20digital%20secrecy%20patterns%2C%20dark%20background%20with%20crimson%20and%20amber%20warm%20highlights%2C%20privacy%20protection%20visual%20metaphor%2C%20minimalist%20composition%20with%20shield%20shapes%2C%20whistleblower%20aesthetic%2C%20clean%20atmospheric%20tone%2C%20no%20text&width=800&height=500&seq=card-submission-guide&orientation=landscape',
    tag: '投稿指南',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          深度网知识卡
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          六大主题知识卡片，快速掌握暗网核心概念与实用技能
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group bg-background-100 border border-background-200/60 rounded-lg overflow-hidden transition-all duration-200"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-950/70 backdrop-blur-sm rounded text-xs font-medium text-primary-300">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors duration-200">
                  {card.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}